import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import LoginForm from "@components/Form/LoginForm";
import FormWrapper from "@components/Wrappers/FormWrapper";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const LoginPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout minimal>
            <Helmet>
                <title>{ `Login to Your Account Profile | ${brand}` }</title>
                <meta name="keywords" content={ `Login to Your Account Profile | ${brand}` } />
                <meta name="description" content={ `Log into your ${brand} account to access
                your membership offers & benefits. Explore tickets to movie showtimes at your nearest
                regional cinema today!` } />
                <link rel="canonical" href={`${window.location.protocol }//${ window.location.host}/login`} />
            </Helmet>
            <FormWrapper pageTitle={`Log in to ${brand}`}>
                <LoginForm />
            </FormWrapper>
        </VersionedLayout>
    );
};

export default LoginPage;
